import { Footer } from '@/components';
import { createClient } from '@/prismicio';
import { GlobalNavBar } from '@/components/common/GlobalNavBar';

const GeneralLayout = async ({ children }: { children: React.ReactNode }) => {
  // Server-render navigation data
  const client = createClient();
  const { data: navData } = await client.getSingle('global_navigation');

  return (
    <div className="flex flex-col min-h-screen">
      {/* Server-rendered header with reserved space */}
      <header className="sticky top-0 z-40 px-5 pt-2.5 mt-[-5.375rem]">
        <div className="backdrop-blur-[47.5px] backdrop-filter h-[72px] rounded-2xl w-full max-w-6xl mx-auto px-6 flex items-center">
          {/* Reserve space for navbar to prevent CLS */}
          <div className="w-full h-[40px] flex items-center justify-between">
            <GlobalNavBar data={navData} />
          </div>
        </div>
      </header>
      {/* Make main content take the remaining height so the footer stays at the bottom */}
      <main className="flex-1">{children}</main>
      {/* Footer renders normally since hero is server-side */}
      <Footer navData={navData} />
    </div>
  );
};

export default GeneralLayout;
